<template>
  <div>
    <label for="file_upload">Or Bulk Upload With A CSV</label>
    <v-alert type="error" :value="errors">{{errors}}</v-alert>
    <v-alert type="info" :value="errors.code === 'TooManyFields'">
      Please make sure you only have 'email,first_name,last_name' as the first line of the CSV.
    </v-alert>
    <input type="file" name="file_upload" accept=".csv" @change="fileUpload($event.target.name, $event.target.files)" />
    <div>Must be a CSV file with email, first_name, last_name as the first row.</div>
  </div>
</template>

<script>
import Papa from "papaparse";
export default {
  data() {
    return {
      errors: ""
    };
  },
  methods: {
    fileUpload(fieldName, fileList) {
      this.errors = "";
      if (!fileList.length) return;
      let file = fileList[0];
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: ({data, errors}) => {
          if (errors.length) {
            this.errors = errors[0];
            return;
          }
          this.$emit("csvUpload", data)
        }
      });
    }
  }
};
</script>
